<template>
  <div>
    <!-- start: page -->
    <form class="ecommerce-form action-buttons-fixed" @submit.prevent="submitForm" novalidate>
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">{{ translations.details }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.customerBankAccount.bankId.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      {{ translations.forms.labels.bank }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="customerBankAccount.bankId"
                        :multiple="false"
                        :options="banks"
                        placeholder="Izaberite banku"
                      />

                      <form-error :model="$v.customerBankAccount.bankId" :label="translations.forms.labels.bank" :dirty="$v.$dirty"/>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.customerBankAccount.companyId.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      {{ translations.forms.labels.company }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="customerBankAccount.companyId"
                        :multiple="false"
                        :options="companies"
                        placeholder="Izaberite kompaniju"
                      />

                      <form-error :model="$v.customerBankAccount.companyId" :label="translations.forms.labels.company" :dirty="$v.$dirty"/>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.customerBankAccount.bankAccount.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      {{ translations.forms.labels.bankAccount }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.bankAccount"
                        v-model="customerBankAccount.bankAccount"
                      />

                      <form-error :model="$v.customerBankAccount.bankAccount" :label="translations.forms.labels.bankAccount" :dirty="$v.$dirty"/>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="action-buttons d-flex justify-content-between">
        <div>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#delete-modal"
            class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
            <i class="bx bx-trash text-4 me-2"></i> {{ translations.delete }}
          </button>
        </div>
        <div class="d-flex gap-3">
          <router-link exact :to="{ name: 'Currencies' }" class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3">
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="
              submit-button
              btn btn-primary btn-px-4
              py-3
              d-flex
              align-items-center
              font-weight-semibold
              line-height-1
            "
            data-loading-text="Loading..."
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>

      <modal id="delete-modal">
        <h5 slot="header"><strong>{{ translations.deleteCustomerBankAccount }}</strong></h5>
        <div slot="body">
          <span v-html="modalText">
          </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button type="button" class="btn btn-primary px-4 mx-2" @click.prevent.stop="deleteCustomerBankAccount" data-bs-dismiss="modal">
                {{ translations.yes }}
              </button>
              <button type="button" class="btn btn-default px-4" data-bs-dismiss="modal">
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import api from '@/services/api';
import { translations } from '@/mixins';
import validations from './valdation-schema/add';
import FormError from '@/components/shared/form-errors/FormError.vue';
import Modal from '@/components/shared/modal/Modal.vue';

export default {
  name: 'AddBank',
  mixins: [translations],
  validations: {
    customerBankAccount: { ...validations },
  },
  components: { FormError, Treeselect, Modal },
  computed: {
    modalText() {
      return this.translations.areYouSureCustomerBankAccount.replace('{bankAccount}', `<strong>${this.customerBankAccount.bankAccount}</strong>`);
    },
    companies() {
      return this.$store.getters.getCompanies.map((item) => {
        return {
          label: item.title,
          id: item.id,
        }
      });
    },
    banks() {
      return this.$store.getters.getBanks.map((item) => {
        return {
          label: item.title,
          id: item.id,
        }
      });
    },
    isFormValid() {
      return !this.$v.$invalid;
    },
    customerBankAccount() {
      return this.$store.getters.getCustomerBankAccount;
    },
  },
  methods: {
    submitForm() {
      this.$v.$touch();

      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }
      
      api
        .updateCustomerBankAccount(this.customerBankAccount)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'CustomerBankAccounts' });
        });
    },
    deleteCustomerBankAccount() {
      api.deleteCustomerBankAccounts([this.customerBankAccount.id])
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'CustomerBankAccounts' });
        }).catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
          this.$router.push({ name: 'CustomerBankAccounts' });
        });
    },
  },
  mounted() {
    this.$store.dispatch('getCustomerBankAccount', this.$route.params.id);
    this.$store.dispatch('getCompanies', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
    this.$store.dispatch('getBanks', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
  },
};
</script>

<style lang="scss" scoped>
.vue-treeselect__placeholder {
  color: #000;
}

.vue-treeselect__placeholder,
.vue-treeselect__single-value {
  line-height: 55px !important;
}

.vue-treeselect__control {
  height: 55px !important;
  font-size: 0.85rem;
}
</style>